import { useCallback, useMemo, useState } from 'react'
import { Virtuoso } from 'react-virtuoso'
import { useReviewers } from '~/entities/reviewer'
import { SearchView, Text } from '~/shared/ui'
import { ReviewerItem } from './reviewer-item'

export function ReviewerFilter() {
  const {
    data: { reviewers },
  } = useReviewers()
  const [searchValue, setSearchValue] = useState('')

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const filteredReviewers = useMemo(() => {
    return reviewers.filter((reviewer) => {
      return (
        reviewer.first_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        reviewer.last_name?.toLowerCase().includes(searchValue.toLowerCase())
      )
    })
  }, [reviewers, searchValue])

  const visibleReviewers = useMemo(() => {
    if (searchValue) {
      return filteredReviewers
    }
    return reviewers
  }, [filteredReviewers, reviewers, searchValue])

  return (
    <SearchView
      value={searchValue}
      onChange={handleSearchChange}
      placeholder="Search"
      forceOpen
      scrollable={false}
    >
      {visibleReviewers.length > 0 ? (
        <>
          {filteredReviewers.length < 6 ? (
            filteredReviewers.map((reviewer) => (
              <ReviewerItem
                key={reviewer.sub}
                reviewer={reviewer}
                searchValue={searchValue}
              />
            ))
          ) : (
            <Virtuoso
              className="min-h-[280px]"
              data={filteredReviewers}
              itemContent={(_, reviewer) => {
                return (
                  <ReviewerItem
                    key={reviewer.sub}
                    reviewer={reviewer}
                    searchValue={searchValue}
                  />
                )
              }}
            />
          )}
        </>
      ) : (
        <Text
          className="box-border w-full px-4 py-3"
          appearance="SUBTITLE"
        >
          No Results
        </Text>
      )}
    </SearchView>
  )
}
